import {Injectable} from '@angular/core';
import {APIService} from "./api.service";
import {ISetLogLevel} from "../interfaces/ISetLogLevel";
import {HttpClient} from "@angular/common/http";
import {AppConfigService} from "./app-config.service";
import {GameTypeEnum} from "../enum/GameTypeEnum";

@Injectable({
  providedIn: 'root'
})
export class LogLevelService {

  constructor(private apiService: APIService,
              private http: HttpClient,
              private appConfigService: AppConfigService) { }

  setLogLevel(commandP: ISetLogLevel, targetP: string) {
    if (targetP.toLowerCase() == "api") {
      return this.apiService.MakePutRequest("log/switch-level", commandP);
    } else if (targetP.toLowerCase() == "admin app"){
      return this.http.put("/api/log/switch-level", commandP);
    }
    let web_app_url = this.getWebAppUrl();
    return this.http.put(`${web_app_url}api/log/switch-level`, commandP);
  }

  public getWebAppUrl(): string {
    if (this.appConfigService.getEnvironment().toLowerCase() == "local") {
      return "http://localhost:4200/"
    } else if (this.appConfigService.getEnvironment().toLowerCase() == "production upei") {
      return `${this.appConfigService.generateWebappDomainUrl("upei", GameTypeEnum.GoldRush)}`;
    }
    return `${this.appConfigService.generateWebappDomainUrl("cospei", GameTypeEnum.GoldRush)}`;
  }
}
